import { connect } from 'react-redux'
import { flatMapUnique } from 'Services/GraphFilterUtils'
import { Badge, Tooltip, Tabs, Statistic, Checkbox, Divider, Row, Col } from 'antd'
import GraphFilterGraphs from '../GraphFilter/GraphFilterGraphs'
import GraphFilterTypes from '../GraphFilter/GraphFilterTypes'
import GraphFilterRelations from '../GraphFilter/GraphFilterRelations'
import { setActiveFilterTab } from 'Actions/graphFilter'
import Feather from '@sysunite/react-feather'

const { TabPane } = Tabs

const checkBoxItems = [{
  key: 'colorByGraph',
  label: 'Color by graph',
  save: true
}, {
  key: 'hideRelationLabels',
  label: 'Hide relation labels',
  save: true
}, {
  key: 'showAttributes',
  label: 'Show attributes in graph',
  save: true,
  isHiddenForAbstractViews: true
}, {
  key: 'showRelevantMetaNodes',
  label: 'Show relevant meta nodes in graph',
  save: true,
  isHiddenForAbstractViews: true
}, {
  key: 'showAllMetaNodes',
  label: 'Show all meta nodes in graph',
  save: true,
  isHiddenForAbstractViews: true
}]

const tabs = [{
  key: 'relations',
  title: 'Relations',
  icon: 'git-branch',
  Component: GraphFilterRelations
}, {
  key: 'types',
  title: 'Types',
  icon: 'circle',
  Component: GraphFilterTypes
}, {
  key: 'graphs',
  title: 'Graphs',
  icon: 'disc',
  Component: GraphFilterGraphs
}]

class GraphFilterPanel extends React.Component {

  constructor(props) {
    super(props)
    this.state = checkBoxItems.reduce((acc, { save, key }) => {
      if (save) {
        return { ...acc, [key]: localStorage.getItem(key) === 'true' }
      } else {
        return acc
      }
    }, {})
  }

  renderCheckboxItem ({ key, label }) {
    const { onChangeFilter } = this.props
    return (
      <Row key={key}>
        <Checkbox
          onChange={({ target: { checked }}) => {
            localStorage.setItem(key, checked)
            onChangeFilter(key, checked)
          }}
          defaultChecked={this.state[key]}
        >
          { label }
        </Checkbox>
      </Row>
    )
  }

  omitAndCount = _.flow(_.omit, _.size)
  onChangeTab = (activeKey) => this.props.setActiveFilterTab(activeKey)
  filterIsActive = (filters) => _.filter(filters, (filter) => !filter.enabled).length > 0

  render() {
    const {
      activeFilterTab,
      relationFilters,
      typeFilters,
      filteredNodes,
      filteredRelations,
      graphFilters,
      nodes,
      edges,
      abstract,
      relNodes,
      showAttributesAndRelationsAsNodes,
      showAttributes
    } = this.props

    const activeFilters = {
      graphs: this.filterIsActive(graphFilters),
      relations: this.filterIsActive(relationFilters),
      types: this.filterIsActive(typeFilters)
    }

    const nodesToHide = flatMapUnique(filteredNodes)
    const relationsToHide = flatMapUnique(filteredRelations)

    let nodeCount, relationCount;

    if (showAttributesAndRelationsAsNodes) {
      nodeCount = this.omitAndCount(nodes, [...nodesToHide, ..._.keys(relNodes)])
      relationCount = this.omitAndCount(edges, relationsToHide) - _.size(_.without(_.keys(relNodes), ...relationsToHide))
    } else {
      nodeCount = this.omitAndCount(nodes, nodesToHide)
      relationCount = this.omitAndCount(edges, relationsToHide)
    }

    return (
      <div className="filter-panel">
        <Tabs
          onChange={this.onChangeTab}
          style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}
          defaultActiveKey={activeFilterTab}
          destroyInactiveTabPane={true}
        >
          {
            tabs.map(({ key, title, icon, Component }) => (
              <TabPane
                tab={
                  <Tooltip trigger='hover' title={title}>
                    <Badge dot={activeFilters[key]}>
                      <Feather type={icon} />
                    </Badge>
                  </Tooltip>
                }
                key={key}
                style={{ position: 'relative' }}
              >
                <Component />
              </TabPane>
            ))
          }
        </Tabs>
        <Divider />
          {
            checkBoxItems.filter(({ isHiddenForAbstractViews }) => {
              if (isHiddenForAbstractViews) {
                return !abstract
              } else {
                return true
              }
            }).map(this.renderCheckboxItem.bind(this))
          }
        <Divider />
        <Row style={{ textAlign: 'center' }} type="flex">
          <Col style={{ flex: 'auto' }}>
            <Statistic title="Relations" value={relationCount} />
          </Col>
          <Col style={{ flex: 'auto' }}>
            <Statistic title="Nodes" value={nodeCount} />
          </Col>
        </Row>
      </div>
    )
  }
}

export default connect(
  ({
    graphFilter: {
      activeFilterTab,
      relationFilters,
      typeFilters,
      filteredNodes,
      filteredRelations,
      graphFilters,
      showAttributesAndRelationsAsNodes,
      showAttributes
    },
    graph: { graphData: { nodes, edges, relNodes, abstract }}
  }) => (
    {
      activeFilterTab,
      relationFilters,
      typeFilters,
      filteredNodes,
      filteredRelations,
      nodes,
      edges,
      relNodes,
      abstract,
      graphFilters,
      showAttributesAndRelationsAsNodes,
      showAttributes,
    }
  )
, { setActiveFilterTab }
)(GraphFilterPanel)
